import { createFileRoute } from "@tanstack/react-router";
import { PageHero, Section } from "@/components/site/section";

export const Route = createFileRoute("/about-us")({
  head: () => ({
    meta: [
      { title: "About Us | Argentinian.Soccer" },
      { name: "description", content: "Who we are: independent fan media built around Argentine football." },
      { property: "og:title", content: "About Us | Argentinian.Soccer" },
      { property: "og:url", content: "/about-us" },
    ],
    links: [{ rel: "canonical", href: "/about-us" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About"
        title="About Us"
        description="Argentinian.Soccer is an independent editorial home for Argentina football, built by supporters who treat it like a craft."
      />
      <Section id="history" eyebrow="History" title="History">
        <div className="prose prose-neutral max-w-3xl space-y-4 text-base text-foreground">
          <p>
            Argentinian.Soccer started as a Telegram channel between three friends arguing about Lionel Scaloni's bench in 2019.
            By the time Argentina lifted the Copa America in 2021, the channel had 40,000 daily readers.
          </p>
          <p>
            We launched as a publication in 2022, fueled by a singular bet: there is room for one editorial home that treats
            Argentine football — National Team, Primera División, and the diaspora abroad — with the depth of a long-form
            magazine and the urgency of a wire desk.
          </p>
          <p>
            Today we publish daily across news, interviews, long-form features, polls, and video. Independent. Reader-supported.
            Argentine football, all the way down.
          </p>
        </div>
      </Section>
    </>
  );
}
